import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { Button, Icon } from '../../../../components';
import Product from '../../store/Product';
import classes from './ProductGrid.module.scss';

export default observer(function ProductGrid({
  products,
}: {
  products: Product[];
}) {
  return (
    <div className={classes.root}>
      {products.map((product) => (
        <Card
          className={classes.card}
          component={Link}
          key={product.id}
          {...{ to: `/products/${product.id}` }}
        >
          <CardActionArea>
            <Cover src={product.coverUrl} title={product.displayName} />
            <CardContent>
              <Typography color="textPrimary" component="p" variant="body2">
                {product.displayName}
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button icon="pen" size="small" type="primaryText">
              Edit
            </Button>
          </CardActions>
        </Card>
      ))}
    </div>
  );
});

export function Cover({ src, title }: { src: string; title: string }) {
  if (src) {
    return <CardMedia component="img" height="140" image={src} title={title} />;
  }

  return (
    <div className={classes.emptyCover}>
      <Icon icon="cube" size={48} sx={{ mr: 0 }} />
    </div>
  );
}
